export default __webpack_public_path__ + "static/media/small.fd79fe6a.jpg";